module.exports = __webpack_public_path__ + "img/pay-value5.dce3c6a1.png";